import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { Container } from 'semantic-ui-react';
import { toast } from 'react-toastify';

export function SupersetDashBoardPage(props) {
  const dashboardRef = useRef(null);
  const [jwtToken, setJWTtoken] = useState(null);

  const hasPermissions = (category) => {
    return !_.isEmpty(props.userPermissions) && props.userPermissions.hasOwnProperty(category);
  };

  const isAdmin = () => {
    return hasPermissions('Other') && props.userPermissions['Other'].actions.admin;
  };

  const canViewDashboard = () => {
    return hasPermissions('Dashboard') && props.userPermissions['Dashboard'].actions.READ || isAdmin();
  };

  useEffect(() => {
    if (props.tenantId !== undefined) {
      if (props.isPermissionsFetched) {
        if (canViewDashboard()) {
          const supersetTokenUrl = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/getSupersetToken?TenantId=${props.tenantId}`;
          console.log('Application origin URL:', window.location.origin);
          fetch(supersetTokenUrl, {
            headers: {
              Authorization: `Bearer ${props.authToken}`,
            },
          }
          ).then((response) => response.json()
          ).then((response) => {
            setJWTtoken(response.token);
          });
        } else {
          toast.error('You do not have permission to view the dashboard.');
        }
      }
    }
  }, [props.tenantId, props.isPermissionsFetched]);

  useEffect(() => {
    if (jwtToken && dashboardRef.current) {
      dashboardRef.current.innerHTML = '';
      console.log('Embedding dashboard with token:', jwtToken);

      embedDashboard({
        id: process.env.REACT_APP_SUPERSET_DB_ID,
        supersetDomain: process.env.REACT_APP_SUPERSET_URL,
        mountPoint: dashboardRef.current,
        fetchGuestToken: () => Promise.resolve(jwtToken),

        dashboardUiConfig: {
          hideTitle: false,
          hideTab: false,
          hideChartControls: false,
          filters: {
            expanded: false
          },

          //urlParams: {
          //  tenantid: props.tenantId,
          //}
        },
        debug: true,
      }).then(() => {
        // Force iframe to full size after embedding
        setTimeout(() => {
          const iframe = dashboardRef.current?.querySelector('iframe');
          if (iframe) {
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            iframe.style.overflow = 'hidden';
          }
        }, 1000);
      }).catch(error => {
        console.error('Dashboard embedding failed:', error);
        toast.error('Failed to load dashboard');
      });

    }
  }, [jwtToken, props.tenantId]);

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
      {canViewDashboard() && (
        <div
          ref={dashboardRef}
          style={{ width: '100%', height: '100%', overflow: 'hidden' }}
        ></div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  tenantId: state.tenantManagement.activeTenant.tenantId,
  userPermissions: _.isEmpty(state.authUserRoles.permissions) ? {} : state.authUserRoles.permissions,
  isPermissionsFetched: state.isPermissionsFetched === true,
  authToken: state.authData?.[0]?.signInUserSession?.accessToken?.jwtToken,
});

export default connect(mapStateToProps)(SupersetDashBoardPage);
